export default __webpack_public_path__ + "987a6766bab398dd662642246dbe0d06.png";